import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import s from './ModelSetpoints.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { initialModelState } from '../../reducers/initialState';
import { v4 as uuidv4 } from 'uuid';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Dropdown from '../WSAControls/DroprdownContainer/Dropdown';
import InputNumber from '../WSAControls/InputNumber/InputNumber';
import classNames from 'classnames';
import { isRequired, sortSetpoints } from '../../utils';
import Cookies from 'js-cookie';
import { useParams } from 'react-router-dom';
import Checkbox from '../WSAControls/CheckboxContainer/Checkbox';

const ModelSetpoints = ({
  ModelSetpointId,
  saveModelSetpoint,
  modelSetpoint = {
    ...initialModelState.modelManager.selectedModel.ModelSetpoints
  },
  changeModelSetpoint,
  modelCategorySetpoints,
  cancelHandler,
  intl
}) => {
  let IsEdit = false;
  const [localformErrors, setFormErrors] = useState({});
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;

  let { ModelId } = useParams();

  if (ModelSetpointId) {
    IsEdit = true;
  }

  // Update redux store
  const setLocalModelSetpoint = currentState => {
    changeModelSetpoint(currentState);
  };

  let widgetCode = IsEdit ? 'MODELSETPOINTSEDIT' : 'MODELSETPOINTSADD';

  const setpointOptions = () => {
    let setpointData = [];
    modelCategorySetpoints.forEach(element => {
      if (
        modelSetpoint &&
        modelSetpoint.modelSetpointList.filter(x => x.SetpointId === element.SetpointId).length === 1
      ) {
        element.isDisabled = true;
      } else {
        element.isDisabled = false;
      }
      setpointData.push({
        ...element,
        label: element.SetpointGroup + ' - ' + element.Name,
        value: element.SetpointId
      });
    });
    return sortSetpoints(setpointData);
  };


  //Saving
  const submitForm = e => {
    e.preventDefault();

    if (!validateInput()) {
      return;
    }

    let saveData = modelSetpoint.selectedModelSetpoint;
    saveData.MarkAsDeleted = false;
    saveData.IsEdit = IsEdit;
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 0;

    if (!IsEdit) {
      saveData.ModelSetpointId = 0;
      saveData.ModelId = ModelId;
      saveData.GuidIdentifier = uuidv4();
    }

    saveModelSetpoint(saveData, widgetCode);
  };

  let selSetpointObj = null;
  if (modelSetpoint.selectedModelSetpoint.SetpointId) {
    selSetpointObj = modelCategorySetpoints.find(
      x => x.SetpointId === modelSetpoint.selectedModelSetpoint.SetpointId
    );
  }


  const validateInput = () => {
    let formErrors = {};
    let isValid = true;

/*

    if (modelSetpoint && modelSetpoint.selectedModelSetpoint && !modelSetpoint.selectedModelSetpoint.SetpointId) {
      //validation for free form fields


      //validation for free form fields

      if (
        !modelSetpoint ||
        !modelSetpoint.selectedModelSetpoint ||
        !modelSetpoint.selectedModelSetpoint.Name ||
        isRequired(modelSetpoint.selectedModelSetpoint.Name, 1)
      ) {
        formErrors.Name = intl.formatMessage({
          id: 'modelSetpoints.setpointNameRequired',
          defaultMessage: 'Setpoint name is a mandatory field'
        });
        isValid = false;
      }

      if (
        !modelSetpoint ||
        !modelSetpoint.selectedModelSetpoint ||
        !modelSetpoint.selectedModelSetpoint.Code ||
        isRequired(modelSetpoint.selectedModelSetpoint.Code, 1)
      ) {
        formErrors.Code = intl.formatMessage({
          id: 'modelSetpoints.setpointCodeRequired',
          defaultMessage: 'Setpoint code is a mandatory field'
        });
        isValid = false;
      }


      if (
        !modelSetpoint ||
        !modelSetpoint.selectedModelSetpoint ||
        typeof modelSetpoint.selectedModelSetpoint.Value !== 'number'
      ) {
        formErrors.DefaultValue = intl.formatMessage({
          id: 'modelSetpoints.setpointValueRequired',
          defaultMessage: 'Setpoint value is a mandatory field'
        });
        isValid = false;
      } else {

        if (
          modelSetpoint && modelSetpoint.selectedModelSetpoint &&
          modelSetpoint.selectedModelSetpoint.MinimumValue !== undefined &&
          modelSetpoint.selectedModelSetpoint.MinimumValue !== '' &&
          modelSetpoint.selectedModelSetpoint.MinimumValue > parseFloat(modelSetpoint.selectedModelSetpoint.Value)
        ) {
          formErrors.DefaultValue = intl.formatMessage({
            id: 'modelSetpoints.ValueMustBeWithinRange',
            defaultMessage: 'Value must be within Min and Max range'
          });
          isValid = false;
        } else if (
          modelSetpoint && modelSetpoint.selectedModelSetpoint &&
          modelSetpoint.selectedModelSetpoint.MaximumValue !== undefined &&
          modelSetpoint.selectedModelSetpoint.MaximumValue !== '' &&
          modelSetpoint.selectedModelSetpoint.MaximumValue < parseFloat(modelSetpoint.selectedModelSetpoint.Value)
        ) {
          formErrors.DefaultValue = intl.formatMessage({
            id: 'modelSetpoints.ValueMustBeWithinRange',
            defaultMessage: 'Value must be within Min and Max range'
          });
          isValid = false;
        }

      }

      setFormErrors(formErrors);
      return isValid
    }
*/
    if (
      !modelSetpoint ||
      !modelSetpoint.selectedModelSetpoint ||
      !modelSetpoint.selectedModelSetpoint.SetpointId ||
      isRequired(modelSetpoint.selectedModelSetpoint.SetpointId, 1)
    ) {
      formErrors.SetpointId = intl.formatMessage({
        id: 'modelSetpoints.setpointRequired',
        defaultMessage: 'Setpoint is a mandatory field'
      });
      isValid = false;
    }

    if (
      !modelSetpoint ||
      !modelSetpoint.selectedModelSetpoint ||
      !modelSetpoint.selectedModelSetpoint.SetpointId ||
      isRequired(modelSetpoint.selectedModelSetpoint.Value, 1)
    ) {
      formErrors.Value = intl.formatMessage({
        id: 'modelSetpoints.ValueRequired',
        defaultMessage: 'Value is a mandatory field'
      });
      isValid = false;
    } else {
      if (
        selSetpointObj &&
        selSetpointObj.MinimumValue !== undefined &&
        selSetpointObj.MinimumValue !== '' &&
        selSetpointObj.MinimumValue > parseFloat(modelSetpoint.selectedModelSetpoint.Value)
      ) {
        formErrors.Value = intl.formatMessage({
          id: 'modelSetpoints.ValueMustBeWithinRange',
          defaultMessage: 'Value must be within Min and Max range'
        });
        isValid = false;
      } else if (
        selSetpointObj &&
        selSetpointObj.MaximumValue !== undefined &&
        selSetpointObj.MaximumValue !== '' &&
        selSetpointObj.MaximumValue < parseFloat(modelSetpoint.selectedModelSetpoint.Value)
      ) {
        formErrors.Value = intl.formatMessage({
          id: 'modelSetpoints.ValueMustBeWithinRange',
          defaultMessage: 'Value must be within Min and Max range'
        });
        isValid = false;
      }
    }

    setFormErrors(formErrors);

    return isValid;
  };

  //on control value change
  const onChange = e => {
    if ((e.target.name == 'Value' || e.target.name == 'MinimumValue' || e.target.name == 'MaximumValue') && e.target.value != '') {
      setLocalModelSetpoint({
        ...modelSetpoint,
        selectedModelSetpoint: { ...modelSetpoint.selectedModelSetpoint, [e.target.name]: Number(e.target.value) }
      });
      
    } else {
      setLocalModelSetpoint({
        ...modelSetpoint,
        selectedModelSetpoint: { ...modelSetpoint.selectedModelSetpoint, [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value }
      });

    }

  };

  const getDefaultValue = id => {
    let setpointId = id ? id : modelSetpoint.selectedModelSetpoint.SetpointId;
    let modelSetpoint = modelCategorySetpoints.filter(x => x.SetpointId === setpointId);

    return modelSetpoint.length > 0 ? modelSetpoint[0].DefaultValue : '';
  };



  const onDropdownChange = e => {
    let defaultValue = getDefaultValue(e.value);

    setLocalModelSetpoint({
      selectedModelSetpoint: {
        ...modelSetpoint.selectedModelSetpoint, SetpointId: e.value,
        Value: defaultValue
      }
    });
  };

  const onCancelButtonClick = () => {
    setLocalModelSetpoint({
      selectedModelSetpoint: {
        ...modelSetpoint.selectedModelSetpoint,
        ...initialModelState.modelManager.selectedModel.ModelSetpoints.selectedModelSetpoint,
        DefaultValue: null
      }
    });
    cancelHandler()
  }

  const defaultHandler = () => {
    setLocalModelSetpoint({
      selectedModelSetpoint: {
        ...modelSetpoint.selectedModelSetpoint,
        Value: getDefaultValue(modelSetpoint.selectedModelSetpoint.SetpointId)
      }
    });
  };
  //let disableControls = modelSetpoint.selectedModelSetpoint.SetpointId ? true : false;
  // This now always true as per the current requirements. Only adding setpoint from  model category setpoints
  let disableControls = true;

  let ddlClass = localformErrors && localformErrors.SetpointId ? s.ddlError : '';
  if (modelSetpoint.redirect) {
    onCancelButtonClick()
  }
  return (
    <div className={s.modelCategorySetpoints}>
      <div className={s.modelSetpointsContent}>
        <Form>
          <div className={s.editScreenRow}>
            <Row>
              {((IsEdit && disableControls) || !IsEdit) && <Col lg={3}>
                <Form.Group controlId="formSetpointName">
                  <Form.Label>
                    <FormattedMessage id="modelSetpoints.selectSetpoint" defaultMessage="Select setpoint" />
                  </Form.Label>
                  <Dropdown
                    id="formSetpointName"
                    dataArray={setpointOptions()}
                    controlData={{ placeholderText: 'Select setpoint', customClassName: ddlClass }}
                    onDropdownChange={onDropdownChange}
                    selectedOption={setpointOptions().filter(
                      option => option.value === modelSetpoint.selectedModelSetpoint.SetpointId
                    )}
                    disabled={IsEdit}
                    data-unittest="formSetpoint"
                  />
                  {localformErrors && localformErrors.SetpointId && (
                    <p role="alert" className={s.error}>
                      {localformErrors.SetpointId}
                    </p>
                  )}
                </Form.Group>
              </Col>}
              {disableControls &&
                <>
                  <Col xs={6} lg={2}>
                    <Form.Group controlId="formSetpointValue">
                      <Form.Label>
                        <FormattedMessage id="modelSetpoints.settingValue" defaultMessage="Select value" />
                      </Form.Label>
                      <InputNumber
                        name="Value"
                        step=".1"
                        onInputChange={onChange}
                        value={modelSetpoint.selectedModelSetpoint.Value}
                        id="formSetpointValue"
                        disabled={!disableControls}
                        customClassName={`${localformErrors && localformErrors.Value ? s.formControlError : ''}`}
                      />
                      {localformErrors && localformErrors.Value && (
                        <p role="alert" className={s.error}>
                          {localformErrors.Value}
                        </p>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs={6}>
                    <p>&nbsp;</p>
                    <p className={s.smallItalic}>
                      {(selSetpointObj && selSetpointObj.MinimumValue !== undefined && selSetpointObj.MinimumValue !== '') ||
                        (selSetpointObj && selSetpointObj.MaximumValue !== undefined && selSetpointObj.MaximumValue !== '') ? (
                        <Fragment>
                          (
                          {selSetpointObj && selSetpointObj.MinimumValue !== undefined && selSetpointObj.MinimumValue !== '' ? (
                            <Fragment>
                              <FormattedMessage id="modelSetpoints.min" defaultMessage="Min" />
                              {` ${selSetpointObj.MinimumValue}`}
                            </Fragment>
                          ) : (
                            ''
                          )}
                          {selSetpointObj && selSetpointObj.MaximumValue !== undefined && selSetpointObj.MaximumValue !== '' ? (
                            <Fragment>
                              {selSetpointObj && selSetpointObj.MinimumValue !== undefined && selSetpointObj.MinimumValue !== ''
                                ? `, `
                                : ''}
                              <FormattedMessage id="modelSetpoints.max" defaultMessage="Max" />
                              {` ${selSetpointObj.MaximumValue}`}
                            </Fragment>
                          ) : (
                            ''
                          )}
                          )
                        </Fragment>
                      ) : (
                        ''
                      )}
                    </p>
                  </Col>
                </>}
            </Row>
            {!disableControls && <>
              <Row>
                <Col lg={3}>
                  <Form.Group controlId="formModelVariantSetpointName">
                    <Form.Label>
                      <FormattedMessage id="modelSetpoints.name" defaultMessage="Name" />
                    </Form.Label>

                    <Form.Control
                      type="text"
                      name="Name"
                      onChange={onChange}
                      placeholder={intl.formatMessage({
                        id: 'modelSetpoints.name',
                        defaultMessage: 'Name'
                      })}
                      value={modelSetpoint.selectedModelSetpoint.Name}
                      className={`${s.formControl} ${localformErrors && localformErrors.Name ? s.formControlError : ''}`}
                      disabled={disableControls}
                    />
                    {localformErrors && localformErrors.Name && (
                      <p role="alert" className={s.error}>
                        {localformErrors.Name}
                      </p>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={3}>
                  <Form.Group controlId="formSetpointsCode">
                    <Form.Label>
                      <FormattedMessage id="modelSetpoints.code" defaultMessage="Code" />
                    </Form.Label>

                    <Form.Control
                      type="text"
                      name="Code"
                      onChange={onChange}
                      value={modelSetpoint.selectedModelSetpoint.Code}
                      className={`${s.formControl} ${localformErrors && localformErrors.Code ? s.formControlError : ''}`}
                      placeholder={intl.formatMessage({
                        id: 'modelSetpoints.code',
                        defaultMessage: 'Code'
                      })}
                      disabled={disableControls}
                    />
                    {localformErrors && localformErrors.Code && (
                      <p role="alert" className={s.error}>
                        {localformErrors.Code}
                      </p>
                    )}
                  </Form.Group>
                </Col>
                <Col lg={3}>
                  <Form.Group controlId="formModelVariantSetpointTranslationcode">
                    <Form.Label>
                      <FormattedMessage id="modelSetpoints.translationCode" defaultMessage="Translation Code" />
                    </Form.Label>

                    <Form.Control
                      type="text"
                      name="TranslationCode"
                      onChange={onChange}
                      value={modelSetpoint.selectedModelSetpoint.TranslationCode}
                      className={`${s.formControl} ${localformErrors && localformErrors.TranslationCode ? s.formControlError : ''}`}
                      placeholder={intl.formatMessage({
                        id: 'modelSetpoints.translationCode',
                        defaultMessage: 'Translation Code'
                      })}
                      disabled={disableControls}
                    />
                    {localformErrors && localformErrors.TranslationCode && (
                      <p role="alert" className={s.error}>
                        {localformErrors.TranslationCode}
                      </p>
                    )}
                  </Form.Group>
                </Col>
                <Col lg={3}>
                  <Form.Group controlId="formModelVariantSetpointsUoM">
                    <Form.Label>
                      <FormattedMessage id="modelSetpoints.uOM" defaultMessage="Unit of Measure" />
                    </Form.Label>

                    <Form.Control
                      type="text"
                      name="UnitOfMeasure"
                      onChange={onChange}
                      value={modelSetpoint.selectedModelSetpoint.UnitOfMeasure}
                      className={`${s.formControl}`}
                      placeholder={intl.formatMessage({
                        id: 'modelSetpoints.uOM',
                        defaultMessage: 'Unit of Measure'
                      })}
                      disabled={disableControls}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <Form.Group controlId="formModelVariantSetpointsDescription">
                    <Form.Label>
                      <FormattedMessage id="modelSetpoints.description" defaultMessage="Description" />
                    </Form.Label>

                    <Form.Control
                      className={s.txtArea}
                      as="textarea"
                      rows="3"
                      name="Description"
                      onChange={onChange}
                      placeholder={intl.formatMessage({
                        id: 'modelSetpoints.description',
                        defaultMessage: 'Description'
                      })}
                      value={modelSetpoint.selectedModelSetpoint.Description}
                      disabled={disableControls}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  <Form.Group controlId="formSetpointsDefaultValue">
                    <Form.Label>
                      <FormattedMessage id="modelSetpoints.defaultValue" defaultMessage="Default value" />
                    </Form.Label>

                    <InputNumber
                      name="Value"
                      step=".1"
                      onInputChange={onChange}
                      value={modelSetpoint.selectedModelSetpoint.Value}
                      id="formSetpointValue"
                      disabled={disableControls}
                      customClassName={`${localformErrors && localformErrors.DefaultValue ? s.formControlError : ''}`}
                    />
                    {localformErrors && localformErrors.DefaultValue && (
                      <p role="alert" className={`${s.error}`}>
                        {localformErrors.DefaultValue}
                      </p>
                    )}
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group controlId="formModelVariantSetpointsMinValue">
                    <Form.Label>
                      <FormattedMessage id="modelSetpoints.minValue" defaultMessage="Min value" />
                    </Form.Label>
                    <InputNumber
                      name="MinimumValue"
                      step=".1"
                      onInputChange={onChange}
                      value={modelSetpoint.selectedModelSetpoint.MinimumValue}
                      id="formSetpointMinimumValue"
                      disabled={disableControls}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group controlId="formModelVariantSetpointsMaxValue">
                    <Form.Label>
                      <FormattedMessage id="modelSetpoints.maxValue" defaultMessage="Max value" />
                    </Form.Label>
                    <InputNumber
                      name="MaximumValue"
                      step=".1"
                      onInputChange={onChange}
                      value={modelSetpoint.selectedModelSetpoint.MaximumValue}
                      id="formModelVariantSetpointMaximumValue"
                      customClassName={`${localformErrors && localformErrors.MaximumValue ? s.formControlError : ''}`}
                      disabled={disableControls}
                    />
                    {localformErrors && localformErrors.MaximumValue && (
                      <p role="alert" className={`${s.error} d-block d-lg-none `}>
                        {localformErrors.MaximumValue}
                      </p>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </>}
            <Row>
              <Col>
                <Checkbox
                  key={uuidv4()}
                  dataArray={[
                    {
                      SKEY: 'IsEditable',
                      target: { type: 'checkbox' },
                      label: intl.formatMessage({
                        id: 'common.isEditable',
                        defaultMessage: 'Is Editable'
                      }),
                      isChecked: modelSetpoint.selectedModelSetpoint.IsEditable
                    }
                  ]}
                  onSelectionChange={onChange}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={ModelSetpointId ? 5 : 4} xs={12}>
                <Button
                  variant="primary"
                  className={classNames(s.margin5, s.btnSaveChanges)}
                  onClick={submitForm}
                  noValidate
                  data-unittest="saveData"
                >
                  <FormattedMessage id="modelSetpoints.saveModelSetpoint" defaultMessage="SAVE" />
                </Button>
                {IsEdit && disableControls && (
                  <Button
                    variant="outline-secondary"
                    className={classNames(s.btnCancel)}
                    onClick={defaultHandler}
                    noValidate
                    data-unittest="saveDefault"
                  >
                    <FormattedMessage id="modelSetpoints.default" defaultMessage="DEFAULT" />
                  </Button>
                )}
                <Button
                  variant="outline-secondary"
                  className={classNames(s.btnCancel)}
                  onClick={onCancelButtonClick}
                  noValidate
                  data-unittest="saveCancel"
                >
                  <FormattedMessage id="modelSetpoints.cancelModelSetpoint" defaultMessage="CANCEL" />
                </Button>
              </Col>
              <Col lg={ModelSetpointId ? 7 : 5}></Col>
            </Row>
          </div>
        </Form>
      </div>
    </div>
  );
};

ModelSetpoints.propTypes = {
  saveModelSetpoint: PropTypes.func.isRequired,
  changeModelSetpoint: PropTypes.func.isRequired,
  modelSetpoint: PropTypes.object.isRequired,
  modelCategorySetpoints: PropTypes.array,
  cancelHandler: PropTypes.func.isRequired
};

export default injectIntl(ModelSetpoints);
